import { LOCAL_STORAGE_KEYS } from '../../../../constants/system/LOCAL_STORAGE_KEYS';
import { SOLUTION_TYPE } from '../../../../constants/user-info/solutionType';
import { isEmptyValue } from '../../../../utils/jsUtils';
import { UserNavLinksConfig } from '../PagesNavBox.settings';

export const getDefaultUserNavLinksConfig = (): UserNavLinksConfig => {
  const savedValue = localStorage.getItem(LOCAL_STORAGE_KEYS.USER_NAV_LINKS);

  const defaultValue: UserNavLinksConfig = {
    [SOLUTION_TYPE.NUTRITION]: [],
    [SOLUTION_TYPE.SCAN_IQ]: [],
    [SOLUTION_TYPE.CHALLENGE]: [],
  };

  if (!savedValue) {
    return defaultValue;
  }

  const parsedValue = JSON.parse(savedValue);
  if (isEmptyValue(parsedValue)) {
    return defaultValue;
  }

  return parsedValue;
};
